import { isFunction, noop } from '../../utils/unit';
import { isReactiveElementProto, throwIfTC39Decorator } from '../elements/decorators';
import { listen } from './events';
/**
 * @param type - The name of the event to listen to.
 * @param options - Configures the event listener.
 */
export function eventListener(type, options = {}) {
    return function (proto, methodName) {
        const decoratorName = eventListener.name;
        // TODO: implement when spec formalized.
        throwIfTC39Decorator(decoratorName, proto);
        if (isReactiveElementProto(decoratorName, proto)) {
            const ctor = proto.constructor;
            ctor.addInitializer((host) => {
                let dispose = noop;
                host.addController({
                    hostConnected() {
                        var _a;
                        if (!isFunction(host[methodName]))
                            return;
                        const target = (_a = options.target) !== null && _a !== void 0 ? _a : host;
                        const listener = host[methodName].bind(host);
                        dispose = listen(target, type, listener, options);
                    },
                    hostDisconnected() {
                        dispose();
                        dispose = noop;
                    }
                });
            });
        }
    };
}
